<template>
  <div
    class="view-charge-wallet-factor remove-body-top-padding d-flex justify-content-center align-items-start mt-sm-5 mt-xxs-1"
  >
    <main class="position-relative col-lg-4 col-sm-7 col-xxs-12 pt-xxs-1 pt-sm-5 px-0">
      <header class="d-flex flex-row justify-content-between px-sm-5 px-xxs-3">
        <h2 class="text-white my-auto">
          {{ portalGeneralInfo.title }}
        </h2>
        <div class="rounded-circle my-3 p-2">
          <b-img :src="fileUrl" height="90" width="90" />
        </div>
      </header>
      <article class="bg-light d-flex flex-column py-4 px-xxs-3 px-md-5 text-dark">
        <p
          v-if="Payment.User.IsSubscribedUser"
          class="description"
          v-html="$t('UserProfile.Subscription.ChargeWalletFactor.ChargeDescription',{FullName:Payment.User.FullName,DownloadedGameCount:Payment.User.DownloadedGameCount,PlayedHTMLGameCount:Payment.User.PlayedHTMLGameCount,Income:Payment.User.Income,Unit:Payment.Price.Unit,RemainedDays:Payment.Subscription.RemainedDays,product: this.globalResources.productTranslation.Single,products: this.globalResources.productTranslation.Plural})"
        />
        <p
          v-if="!Payment.User.IsSubscribedUser"
          class="description"
          v-html="$t('UserProfile.Subscription.BuySubscriptionFactor.BuyDescription',{FullName:Payment.User.FullName})"
        />
        <section class="w-100 d-flex flex-column">
          <div class="seperator-line my-2" />
          <section
            v-if="!Payment.Price.InEditMode"
            class="d-flex justify-content-between align-items-center py-3"
          >
            <div>
              <span
                class="text-secondary"
              >
                {{ $t("UserProfile.Subscription.ChargeWalletFactor.ChargeAmount") }}
              </span>
              <b-link class="px-2" @click="ShowPriceInput()">
                <img src="@/assets/icons/pencil-edit-button.svg" height="15">
              </b-link>
            </div>
            <div class="text-secondary">
              {{ Payment.Price.Value }}
              {{ Payment.Price.Unit }}
            </div>
          </section>
          <section
            v-if="Payment.Price.InEditMode"
            class="d-flex justify-content-between align-items-center py-3"
          >
            <b-input-group>
              <b-input-group-prepend>
                <b-button variant="light" class="border" @click="SetPriceMode(false)">
                  <img class="bidi-icon" src="@/assets/icons/back.svg" height="22">
                </b-button>
              </b-input-group-prepend>

              <b-form-input v-model="updatedPrice" dir="ltr" type="number" />

              <b-input-group-append>
                <b-button
                  variant="primary"
                  @click="UpdatePrice()"
                >
                  {{ $t("UserProfile.Subscription.Apply") }}
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </section>
          <b-button
            class="flex-basis-auto col-sm-6 col-xxs-12 align-self-end"
            variant="success"
            size="lg"
            @click="chargeWalletStore"
          >
            {{ $t("UserProfile.Subscription.Payment") }}
          </b-button>
          <img
            class="mt-3 align-self-end"
            width="48"
            height="48"
            src="@/assets/icons/ZarinPal.png"
          >
        </section>
        <div class="angles">
          <div class="angle-right position-absolute" />
          <div class="angle-left position-absolute" />
        </div>
      </article>
      <div class="barcode bg-light py-2 d-flex justify-content-center">
        <div class="barcode-image" />
      </div>
      <footer class="d-flex justify-content-between align-items-center px-xxs-2 px-sm-5">
        <b-link
          :href="portalConfigurations.general.linkToTel"
          class="footer-link text-decoration-none"
        >
          {{ portalConfigurations.general.telText }}
        </b-link>
        <b-link target="_blank" class="footer-link py-2 text-decoration-none">
          {{ portalConfigurations.general.linkUrl }}
        </b-link>
        <span class="footer-link">
          {{ footer.currentDate }}
        </span>
      </footer>
    </main>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import utility from '@/utilities/utility.js'

export default {
  name: 'ChargeWalletFactor',
  data () {
    return {
      footer: {
        currentDate: new persianDate(new Date()).format('L')
      },
      updatedPrice: 0,
      Payment: {
        Price: {
          Value: '',
          Unit: 'تومان',
          InEditMode: false
        },
        User: {
          // UserName: "M_A",
          // FullName: "اسماعیل آزاد",
          // IsSubscribedUser: false,
          // Income: 50000,
          // DownloadedGameCount: 24,
          // PlayedHTMLGameCount: 35
        },
        Subscription: {
          SubscriptionTime: 'یک ماه',
          RemainedDays: 90

        }
      }
    }
  },
  computed: {
    ...mapGetters({
      portalConfigurations: 'tenantDesign/config',
      fileUrlConfiguration: 'cdn/fileUrl',
      chargePrice: 'order/chargePrice',
      userInfo: 'userDemographic/userInfo'
    }),
    portalGeneralInfo () {
      return this.portalConfigurations.general
    },
    fileUrl () {
      if (this.portalConfigurations.general.logoWithTitleUrl) {
        return this.fileUrlConfiguration(
          this.portalConfigurations.general.logoWithTitleUrl
        )
      }
    }
  },
  methods: {
    ...mapActions({
      loadUserInfo: 'userDemographic/loadUserInfo',
      chargeWallet: 'order/charge'
    }),
    SetInitialData () {
      if (this.userInfo.username === undefined) {
        this.loadUserInfo().then(response => {
          this.Payment.User = {
            FirstName: response.body.result.firstName !== undefined ? response.body.result.firstName : '',
            LastName: response.body.result.lastName !== undefined ? response.body.result.lastName : '',
            Biography: response.body.result.bio !== undefined ? response.body.result.bio : '',
            UserName: response.body.result.username !== undefined ? response.body.result.username : '',
            Nickname: response.body.result.nickName !== undefined ? response.body.result.nickName : '',
            DateOfBirth: response.body.result.birthDate !== undefined ? response.body.result.birthDate : '',
            Gender: '',
            Cellphone: response.body.result.phoneNumber
              ? response.body.result.phoneNumber
              : '',
            Email: response.body.result.email ? response.body.result.email : ''
            // FullName: response.body.result.firstName + " " + response.body.result.lastName
          }
        })
      } else {
        this.Payment.User = {
          FirstName: this.userInfo.firstName !== undefined ? this.userInfo.firstName : '',
          LastName: this.userInfo.lastName !== undefined ? this.userInfo.lastName : '',
          Biography: this.userInfo.bio !== undefined ? this.userInfo.bio : '',
          UserName: this.userInfo.username !== undefined ? this.userInfo.username : '',
          Nickname: this.userInfo.nickName !== undefined ? this.userInfo.nickName : '',
          DateOfBirth: this.userInfo.birthDate !== undefined ? this.userInfo.birthDate : '',
          Gender: '',
          Cellphone: this.userInfo.phoneNumber !== undefined ? this.userInfo.phoneNumber : '',
          Email: this.userInfo.email !== undefined ? this.userInfo.email : ''
          // FullName: this.userInfo.firstName + " " + this.userInfo.lastName
        }
      }
      this.Payment.User.FullName = this.Payment.User.FirstName + ' ' + this.Payment.User.LastName
      if (this.Payment.User.FullName === ' ') {
        this.Payment.User.FullName = this.Payment.User.Nickname
      }
    },
    SetPriceMode (mode) {
      this.Payment.Price.InEditMode = mode
    },

    SetPriceInputValue () {
      this.updatedPrice = this.Payment.Price.Value
    },

    ShowPriceInput () {
      this.SetPriceInputValue()
      this.SetPriceMode(true)
    },

    UpdatePrice () {
      this.Payment.Price.Value = this.updatedPrice
      this.SetPriceMode(false)
    },
    chargeWalletStore () {
      let input = {}
      input.value = this.Payment.Price.Value
      this.chargeWallet(input).then(response => {
        window.location.href = response.body.result
      })
    }
  },

  mounted () {
    this.Payment.Price.Value = this.chargePrice
    // let user = utility.getQueryStringValue("user");
    // if (user === "1") {
    //   this.Payment.User.IsSubscribedUser = true;
    // }
    this.SetInitialData()
  },
  created () {
    this.SetInitialData()
  }
}
</script>
